// src/components/LikeDislike/Buttons/DislikeButton.tsx

import React, { useState } from "react";
import { AskResponse, FeedBackReq } from "../../../api";
import { sendDataLikeDislikeButton } from "../../../api";
import { useKeepData } from "../CustomHooks";
import { getDateWithFormat, getTimeWithFormat } from "../../../scripts/globalFunctions";
import { dataModalDislike } from "../Interfaces";
import { ModalDislikeButton } from "../Modals/ModalDislikeButton";
import ThumbDown from "../../../assets/svgComponents/ThumbDown";
import ThumbDownDark from "../../../assets/svgComponents/ThumbDownDark";
import { useUser } from "../../../contexts/useUserData";

import styles from "../buttonAndModalStyles.module.css";

interface PropsData {
    answer: [user: string, response: AskResponse];
    index: number;
    feedbackStatus: 'none' | 'liked' | 'disliked' | undefined;
    setFeedback: (type: "like" | "dislike", index: number) => void;
}

export const DislikeButton: React.FC<PropsData> = ({ answer, index, feedbackStatus, setFeedback }) => {
    const [statusModal, toggleStatusModal] = useState<boolean>(false);
    const [checkFilled, toogleCheckFilled] = useState<boolean>(false);
    const { user, seccion, token } = useUser();
    const keepData = useKeepData();
    const [isSubmitting, setIsSubmitting] = useState<boolean>(false);

    const closeModal = () => {
        const modalElement = document.getElementById(`modalDislike-${index}`);
        modalElement?.classList.remove(styles.modalDislikeOpen);
        toggleStatusModal(false);
    };

    const disLikeClicked = () => {
        if (feedbackStatus !== 'none' || isSubmitting) return;
        if (!statusModal) {
            const date = new Date();
            // Set data using custom hook
            keepData.setQuestion(answer[0]);
            keepData.setMessageId(answer[1].messageId || "");
            keepData.setAnswer(answer[1].answer);
            keepData.setScope(answer[1].scope);
            keepData.setNegocio(answer[1].negocio);
            keepData.setAcceso(answer[1].acceso);
            keepData.setCentro(answer[1].centro);
            keepData.setLinks(answer[1].links);
            keepData.setAzsLinks(answer[1].azs_links);
            if (answer[1].question_intention) {
                keepData.setQuestionIntention(answer[1].question_intention);
            }
            if (answer[1].selected_button) {
                keepData.setSelectedButton(answer[1].selected_button);
            }
            if (answer[1].language) {
                keepData.setLanguage(answer[1].language);
            }
            if (answer[1].chain_of_thought) {
                keepData.setChainOfThought(answer[1].chain_of_thought);
            }
            keepData.setDate(getDateWithFormat(date));
            keepData.setTime(getTimeWithFormat(date));

            const modalElement = document.getElementById(`modalDislike-${index}`);
            modalElement?.classList.add(styles.modalDislikeOpen);
            toggleStatusModal(true);
        }
    };

    const submitDataModal = async (dataModal: dataModalDislike) => {
        if (feedbackStatus !== 'none' || isSubmitting) return;
        setIsSubmitting(true);
        try {
            closeModal();
            const dataSend: FeedBackReq = {
                messageId: keepData.data.messageId,
                Question: keepData.data.question,
                Answer: keepData.data.answer,
                Scope: keepData.data.scope,
                Negocio: keepData.data.negocio,
                Acceso: keepData.data.acceso,
                Centro: keepData.data.centro,
                Docs_respuesta: keepData.data.links,
                Docs_otros_enlaces: keepData.data.azs_links,
                Content: {
                    OK: true,
                    FeedbackComment: dataModal.FeedbackCommentContent,
                },
                Links: {
                    OK: dataModal.FeedbackCheckboxLinks,
                    FeedbackComment: dataModal.FeedbackCommentLinks,
                },
                Reason: {
                    OK: dataModal.FeedbackCheckboxReason,
                    FeedbackComment: dataModal.FeedbackCommentReason,
                },
                OverallFeedback: "KO",
                PartitionKey: keepData.data.time,
                ButtonClickTime: dataModal.submitClickTime,
                question_intention: keepData.data.question_intention,
                selected_button: keepData.data.selected_button,
                language: keepData.data.language,
                chain_of_thought: keepData.data.chain_of_thought
            };

            let final_token = "";
                if (token) {
                    final_token = token;
                }

            const result = await sendDataLikeDislikeButton(dataSend, final_token);
            console.log(result);
            setFeedback("dislike", index);

        } catch (error) {
            console.error("Error sending dislike feedback:", error);
        } finally {
            setIsSubmitting(false);
        }
    };

    const isClicked = feedbackStatus === 'disliked';
    const isDisabled = feedbackStatus !== 'none' && feedbackStatus !== undefined;

    return (
        <div>
            <button
                id={`buttonDislike-${index}`}
                className={`${styles.dislike} ${isClicked ? styles["active"] : ""} ${styles.tooltipdislike}`}
                type="button"
                onClick={disLikeClicked}
                disabled={isDisabled || isSubmitting}
                aria-label="Dislike"
            >
                {/* Rotate the icon by 180 degrees */}
                {isClicked ? (
                    <ThumbDownDark style={{ transform: "rotate(180deg)" }} />
                ) : (
                    <ThumbDown style={{ transform: "rotate(180deg)" }} />
                )}
                {!isClicked && feedbackStatus !== 'liked' && (
                    <span className={styles.tooltipdisliketext}>Sugerencia de mejora</span>
                )}            
            </button>
            <ModalDislikeButton submitData={submitDataModal} statusModal={closeModal} index={index} />
        </div>
    );
};
